import { buildVersionSchema } from '@/core/build-version.schema';

// Read from index.html, not import.meta.env: a sha inlined in a chunk renames every chunk on each release.
export function buildVersion(): string | undefined {
  const parsed = buildVersionSchema.safeParse(
    document
      .querySelector('meta[name="build-version"]')
      ?.getAttribute('content')
  );
  return parsed.success ? parsed.data : undefined;
}
